module.exports = __webpack_public_path__ + "media/images/pc/stores/sapporo/sapporo_concept_01-fa66b0943bfd07afeee29811c3475c5b.jpg";